// extracted by mini-css-extract-plugin
export default {"wrapper":"TaskEdit_wrapper__W3uno","field":"TaskEdit_field__VdNCy"};